export default class CommonGetters {
  /**
   * Getters by ID
   */
  static getCountryById (countryID, countries) {
    let countryIndex = countries.findIndex(country => country.id === countryID);

    if (countryIndex > -1) {
      return countries[countryIndex].name;
    }

    return '-';
  }

  static getCurrencyById (currencyID, currencies) {
    let currencyIndex = currencies.findIndex(currency => currency.id === currencyID);

    if (currencyIndex > -1) {
      return currencies[currencyIndex].code;
    }

    return '-';
  }

  static getSourceById (sourceID, sources) {
    let sourceIndex = sources.findIndex(source => source.id === sourceID);

    if (sourceIndex > -1) {
      return sources[sourceIndex].name;
    }

    return '-';
  }

  /**
   * Getters for select fields
   */
  static getCountriesForSelect (countries) {
    return countries.map(country => ({
      value: country.id,
      text: country.name
    }));
  }

  static getCountriesCodesForSelect (countries) {
    return countries.map(country => ({
      value: country.code,
      text: country.code + ' (' + country.name + ')'
    }));
  }

  static getCurrenciesForSelect (currencies) {
    return currencies.map(currency => ({
      value: currency.id,
      text: currency.code
    }));
  }

  static getSourcesForSelect (sources) {
    return sources.map(source => ({
      value: source.id,
      text: source.name
    }));
  }
}
